// ═══════════════════════════════════════════════════════════════
// HOOK: useSalaryHistory
// Carga el historial de salarios de un empleado
// ═══════════════════════════════════════════════════════════════

import { useState, useEffect, useCallback } from 'react';
import { salaryHistoryAPI } from '../api/salaryHistory';

export function useSalaryHistory(employeeId) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!employeeId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await salaryHistoryAPI.getByEmployee(employeeId);
      setHistory(data.history || []);
    } catch (err) {
      console.error('Error cargando historial de salarios:', err);
      setError('No se pudo cargar el historial de salarios');
    } finally {
      setLoading(false);
    }
  }, [employeeId]);

  useEffect(() => {
    load();
  }, [load]);

  return { history, loading, error, reload: load };
}
